export const appConfig = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1',
  appName: '3LA Manager',
  tagline: 'Gestão inteligente para sua empresa.',
  organization: {
    id: 'org_3la_labs',
    name: '3LA Labs',
    fantasyName: '3LA Labs',
  },
};
